import(/* webpackMode: "eager", webpackExports: ["LoginForm"] */ "/home/vsts/work/1/s/apps/website/src/app/(frontend)/[locale]/(user)/(auth)/login/loginForm.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThirdPartyAuth"] */ "/home/vsts/work/1/s/apps/website/src/components/auth/thirdPartyAuth.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InputField"] */ "/home/vsts/work/1/s/apps/website/src/components/form/inputField.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PasswordField"] */ "/home/vsts/work/1/s/apps/website/src/components/inputs/passwordField.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TranslationsProvider"] */ "/home/vsts/work/1/s/apps/website/src/modules/localization/translations.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/vsts/work/1/s/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/next/dist/client/image-component.js");
